import { render, staticRenderFns } from "./ViewRoot.vue?vue&type=template&id=0382d302"
import script from "./ViewRoot.vue?vue&type=script&lang=js"
export * from "./ViewRoot.vue?vue&type=script&lang=js"
import style0 from "./ViewRoot.vue?vue&type=style&index=0&id=0382d302&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports